import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

import { OptimizationProcess } from '../../../types/optimizationProcesses'
import { update } from '../../../utils/api'
import { ApiErrors, handleApiErrors } from '../../../utils/apiErrors'

type UpdatePayload = {
  id: number
  name: string
  notes: string
  official: boolean
}

export const useUpdateOptimizationProcess = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation(
    ['optimization-processes', 'update'],
    ({ id, name, notes, official }: UpdatePayload) =>
      update<OptimizationProcess>(`/optimization-processes/${id}/`, {
        name,
        notes,
        official,
      }),
    {
      onError: (error: AxiosError<ApiErrors>) => {
        handleApiErrors(error)
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['optimization-processes'])
        toast.success(t('Optimization process updated successfully'))
      },
    }
  )
}
